module.exports = __webpack_public_path__ + "Icono_RecepcionRevisionMaterial_126px.png";